import { Entity, Field } from '@adornis/baseql/decorators.js';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity.js';

// ---------------------------------------------------------------------------
// CRM Mapping — Links a CampaignLead to its corresponding CRM record.
// Kept in a separate collection (rather than fields on CampaignLead) so a
// single contact deduplicated across multiple campaigns maps cleanly,
// and because mapping data is provider-specific.
// ---------------------------------------------------------------------------

@Entity()
export class CrmMapping extends MongoEntity {
  static override _class = 'CrmMapping';
  static override _collectionName = 'crm_mappings';

  @Field(type => String) userId!: string;
  @Field(type => String) provider!: string;
  @Field(type => String) connectionId!: string;

  @Field(type => String) leadId!: string;
  @Field(type => String) crmContactId!: string;

  /** ISO timestamp of last successful push to CRM */
  @Field(type => String) lastPushedAt?: string;
  @Field(type => String) lastError?: string;

  @Field(type => String) createdAt!: string;
}
